import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PADAgreenment } from "../../components/PADAgreenment";

export const PADAgreenmentPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Pre-Authorized Debit (PAD) Agreement"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Pre-Authorized Debit (PAD) Agreement", navigateTo: "#" }
      ]}
      mainContents={<PADAgreenment />}
    />
  );
};
